import { hasCompanyManagerOrAdminRole } from '../../utils/roles';
import useDashboardPaymentScheduleCalendar from './useDashboardPaymentScheduleCalendar';

const useDashboardScheduleTimeline = ({
  t,
  user,
  selectedGroupId,
  timelineFilters,
  timeline,
  isTimelineLoading,
}) => {
  const calendarState = useDashboardPaymentScheduleCalendar({ t, user, selectedGroupId });

  const hasTimelinePeriod =
    !!timelineFilters?.groupID && !!timelineFilters?.startDate && !!timelineFilters?.endDate;
  const shouldRenderTimeline = hasCompanyManagerOrAdminRole(user) && hasTimelinePeriod;
  const isTimelineEmpty = shouldRenderTimeline && Array.isArray(timeline) && !timeline.length;
  const isTimelineSectionLoading = shouldRenderTimeline && (!timeline || isTimelineLoading);

  return {
    ...calendarState,
    shouldRenderTimeline,
    isTimelineEmpty,
    isTimelineSectionLoading,
    currentPeriod: calendarState.currentPeriod,
    nextPeriod: calendarState.nextPeriod,
  };
};

export default useDashboardScheduleTimeline;
